export enum EStorageType {
  localStorage = 'localStorage',
  sessionStorage = 'sessionStorage',
}
